import { motion } from "framer-motion";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className={`whitespace-nowrap px-8 ${i % 2 === 0 ? "font-serif italic text-xl text-gold-light/90" : "font-mono text-xs uppercase tracking-[0.25em] text-white/60"}`}>
            {item}
          </span>
          <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative bg-navy-2 border-y border-gold/20 py-5 overflow-hidden" data-testid="editorial-marquee">
      <motion.div
        className="flex w-max"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 48, ease: "linear", repeat: Infinity }}
      >
        {row(false)}
        {row(true)}
      </motion.div>
    </div>
  );
}
